import React, {createContext, useState, useContext, ReactNode} from 'react';
import {audioEngine} from "../components/audioMap";

interface MuteContextType {
    isMuted: boolean;
    toggleMute: () => void;
}

const MuteContext = createContext<MuteContextType | undefined>(undefined);

interface MuteProviderProps {
    children: ReactNode;
}

export const MuteProvider: React.FC<MuteProviderProps> = ({children}) => {
    const [isMuted, setIsMuted] = useState<boolean>(false);

    const toggleMute = () => {
        audioEngine.playSFX("tap")
        setIsMuted(prev => !prev);
    }

    return (
        <MuteContext.Provider value={{isMuted, toggleMute}}>
            {children}
        </MuteContext.Provider>
    );
};

export const useMute = (): MuteContextType => {
    const context = useContext(MuteContext);
    if (!context) {
        throw new Error('useMute must be used within a MuteProvider');
    }
    return context;
};
